import { render, staticRenderFns } from "./CorrectionNotePopup.vue?vue&type=template&id=7ca44b19&scoped=true"
import script from "./CorrectionNotePopup.vue?vue&type=script&lang=js"
export * from "./CorrectionNotePopup.vue?vue&type=script&lang=js"
import style0 from "./CorrectionNotePopup.vue?vue&type=style&index=0&id=7ca44b19&prod&lang=css"
import style1 from "./CorrectionNotePopup.vue?vue&type=style&index=1&id=7ca44b19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca44b19",
  null
  
)

export default component.exports